import {
  Backdrop,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useEffect, useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import { useToolbarStyles } from '../CommonMethods/ClientSecretCommonMethods';
import { UserMessageGroup } from '../Model/ClientSecretesModel';
import { clientsecretService } from '../ClientSecretService';
import AddEditGroupToolbar from './AddEditGroupToolbar';
import Cancel from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import LoopIcon from '@mui/icons-material/Loop';
import {
  DataGrid,
  GridColDef,
  GridRowModel,
  GridRowSelectionModel,
} from '@mui/x-data-grid';
import CustomButton from '../../../../Common/Components/Controls/InputControls';
import { showToast } from '../../../../lib/toast';
import { useTranslation } from 'react-i18next';
export default function AddEditGroup(
  props: Readonly<{
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    clientId: string;
    customerId: string;
  }>,
) {
  const [open, setOpen] = useState(true);
  const { t } = useTranslation('clientsecret');
  const { classes } = useToolbarStyles();
  const [add, setAdd] = React.useState(false);
  const initialclientgroups: UserMessageGroup[] = [];
  const [clientSecretGroups, setClientSecretGroups] =
    React.useState(initialclientgroups);
  const initialselectedRowsIds: number[] = [];
  const [clientGroupsCount, setClientGroupsCount] = React.useState(0);
  const [selectedRowRnos, setSelectedRowRnos] = React.useState(
    initialselectedRowsIds,
  );
  const [clientsGroupsPageNo, setClientsGroupsPageNo] = React.useState(1);
  const [loading, setLoading] = React.useState(true);
  const [loadingMore, setLoadingMore] = React.useState(false);

  const AddEditheadRows: GridColDef[] = [
    {
      field: 'Name',
      headerName: 'Group Name',
      description: 'Group Name',
      editable: false,
      width: 500,
      resizable: true,
    },
    {
      field: 'Id',
      headerName: 'Group ID',
      description: 'Group ID',
      editable: false,
      width: 200,
      resizable: true,
    },
    {
      field: 'deleteButton',
      headerName: 'Actions',
      description: 'Actions',
      sortable: false,
      width: 160,
      renderCell: (params) => {
        return (
          <Tooltip title={t('clientsecret.info.remove_group')}>
            <IconButton
              onClick={(e) => onDeleteButtonClick(e, params.row)}
              color="primary"
              size="large"
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const loadMoreItems = () => {
    setLoadingMore(true);
    clientsecretService
      .getClientGroups(props.customerId, props.clientId, getGroupPageNumber())
      .then((data) => {
        setClientSecretGroups((clientgroups) => [
          ...clientgroups,
          ...data.Items,
        ]);
      })
      .then(() => setLoadingMore(false));
  };
  const handleAdd = () => {
    setAdd(true);
  };
  const massdelete = () => {
    RemoveGroups(selectedRowRnos);
  };

  function RemoveGroups(groupsrnos: number[]) {
    setLoading(true);
    clientsecretService
      .removeGroupsFromClient(props.customerId, props.clientId, groupsrnos)
      .then((result) => {
        setClientSecretGroups(result.Items);
        setLoading(false);
        showToast({
          title: t('clientsecret.success.remove_groups'),
          type: 'success',
        });
      });
  }
  const onDeleteButtonClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    row: GridRowModel,
  ) => {
    e.stopPropagation();
    const grouprnos: number[] = [row.GroupRno];
    RemoveGroups(grouprnos);
  };

  const onRowsSelectionHandler = (ids: GridRowSelectionModel) => {
    const selectedRowsData = ids.map((id) => {
      const row = clientSecretGroups.find((row) => row.Id === id);
      if (row !== undefined) return row.GroupRno;
      return null;
    });
    setSelectedRowRnos(
      selectedRowsData.filter((value) => value !== null) as number[],
    );
  };
  const handleClose = () => {
    props.setOpen(false);
    setOpen(false);
  };
  const getGroupPageNumber = () => {
    setClientsGroupsPageNo(clientsGroupsPageNo + 1);
    return clientsGroupsPageNo;
  };
  async function GetClientGroups() {
    try {
      await clientsecretService
        .getClientGroupsCount(props.customerId, props.clientId)
        .then((clientgroups) => {
          setClientGroupsCount(clientgroups);
        });
    } catch (error) {
      showToast({
        title: t('clientsecret.error.fetch_groups'),
        type: 'error',
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
    clientsecretService
      .getClientGroups(props.customerId, props.clientId, getGroupPageNumber())
      .then((data) => {
        setClientSecretGroups(data.Items);
      })
      .then(() => setLoading(false));
  }
  useEffect(() => {
    GetClientGroups();
  }, []);

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Groups</DialogTitle>
        <DialogContent className={classes.DialogContent}>
          <div>
            {loading ? (
              <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : (
              <>
                {!add ? (
                  <div>
                    <div style={{ float: 'left' }}>
                      <Typography className={classes.typo}>
                        Listing {clientSecretGroups.length} of{' '}
                        {clientGroupsCount}
                      </Typography>
                    </div>
                    <div style={{ float: 'right', display: 'inline-flex' }}>
                      {selectedRowRnos.length > 0 ? (
                        <CustomButton
                          startIcon={<DeleteIcon />}
                          onClick={massdelete}
                          label="Groups"
                        />
                      ) : null}
                      <Tooltip title={t('clientsecret.info.add_group')}>
                        <CustomButton
                          variant="contained"
                          startIcon={<AddIcon />}
                          onClick={handleAdd}
                          label="Groups"
                        />
                      </Tooltip>
                    </div>
                  </div>
                ) : null}
                <AddEditGroupToolbar
                  onclickAdd={setAdd}
                  addclicked={add}
                  onClose={handleClose}
                  clientId={props.clientId}
                  customerId={props.customerId}
                />
              </>
            )}
            {!add && clientSecretGroups.length > 0 ? (
              <div
                style={{ height: 400, width: '100%', display: 'inline-block' }}
              >
                <div className={classes.root}>
                  {loadingMore ? (
                    <Backdrop className={classes.backdrop} open={loading}>
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  ) : null}
                </div>
                <DataGrid
                  getRowId={(row) => row.Id}
                  className={classes.DataGridCell}
                  rows={clientSecretGroups}
                  columns={AddEditheadRows}
                  checkboxSelection
                  disableRowSelectionOnClick
                  hideFooterPagination
                  hideFooterSelectedRowCount
                  onRowSelectionModelChange={(ids: GridRowSelectionModel) =>
                    onRowsSelectionHandler(ids)
                  }
                />
                {clientSecretGroups.length !== clientGroupsCount ? (
                  <Tooltip title={t('clientsecret.info.load_more_groups')}>
                    <CustomButton
                      startIcon={<LoopIcon />}
                      onClick={loadMoreItems}
                      label={'more'}
                    />
                  </Tooltip>
                ) : null}
              </div>
            ) : null}
          </div>
        </DialogContent>
        <DialogActions>
          <CustomButton
            onClick={handleClose}
            startIcon={<Cancel />}
            label="Cancel"
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}
